import { render, staticRenderFns } from "./HiSubPage.vue?vue&type=template&id=0fe6c53c&scoped=true&"
import script from "./HiSubPage.vue?vue&type=script&lang=js&"
export * from "./HiSubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6c53c",
  null
  
)

export default component.exports